import { render, staticRenderFns } from "./xeBarSetting.vue?vue&type=template&id=f5a1810a"
import script from "./xeBarSetting.vue?vue&type=script&lang=js"
export * from "./xeBarSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports